import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Input from "@mui/material/Input";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import EmailIcon from "@mui/icons-material/Email";
import NotesIcon from "@mui/icons-material/Notes";

// import UserCreateForm from "./UserCreateForm";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

import { axiosDelay } from "../../../config/config";

import {
    appSetAlert
} from "../../../redux/app/appActions";

import {
    dataReloadDependants
} from "../../../redux/data/dataActions";

const PREFIX = 'UserGroupNewDialog';

const classes = {
    dialogContent: `${PREFIX}-dialogContent`,
    form: `${PREFIX}-form`,
    margin: `${PREFIX}-margin`,
    formEmbeddedActions: `${PREFIX}-formEmbeddedActions`
};

const StyledDialog = styled(Dialog)((
    {
        theme
    }
) => ({
    [`& .${classes.dialogContent}`]: {
        minWidth: '400px',
        maxWidth: '400px',
        minHeight: '320px',
        maxHeight: '320px'
    },

    [`& .${classes.form}`]: {
        height: '300px'
    },

    [`& .${classes.margin}`]: {
        margin: '8px', // theme.spacing(1),
        width: 'calc(100% - 8px)'
    },

    [`& .${classes.formEmbeddedActions}`]: {
        position: 'absolute',
        bottom: '0px',
        width: 'calc(100% - 32px)'
    }
}));

export default function UserGroupNewDialog({ availableGroupTypes, handleClose }) {


    const schema = yup.object().shape({
        email: yup.string().email().required(),
        groupType: yup.string().required()
    });

    const resolver = yupResolver(schema);
    const { register, trigger, handleSubmit, formState, formState: { errors } } = useForm({ resolver });
    const dispatch = useDispatch();

    // Component State
    const [open, setOpen] = React.useState(true);
	const [groupTypes, setGroupTypes] = React.useState([]);
	const [groupType, setGroupType] = React.useState();

    // App State
    const config = useSelector(state => state.config);

    useEffect(() => {
        const r = [];

		for (const group of availableGroupTypes) {
			r.push({ value: group.projectGroupID, label: group.groupName });
		}

		setGroupTypes(r);
    }, []);

    const onSubmit = dataToPost => {
        // TODO: Any additional validation
        createUser(dataToPost);
    };

    const createUser = dataToPost => {
        // Before we post get the user's ObjectID
        setTimeout(function () {

            const postBody = {
                "email": dataToPost.email,
                "projectGroupID": dataToPost.groupType,
            };

            const apiUrl = '{0}ProjectUser?db={1}'.format(config.data.authentication.api, config.data.authentication.apiSource);

            // Here we pass a date time stamp to ensure the latest config is always loaded
            axios
                .post(apiUrl, postBody)
                .then(function (response) {

                    dispatch(appSetAlert(null, '{0} was successfully updated.'.format(dataToPost.email), 'success', 10000));

                    // Refresh Dependant Data Sources
                    // dispatch(dataReloadDependants(["vwUserRole", "user"]));

                    // Close the dialog and signal a reload
                    handleClose(true);

                })
                .catch(function (error) {
                    console.log('**ERROR**', error);

                    dispatch(appSetAlert('Whoops!', 'Something went seriously wrong. Please try again.', 'error', 10000));

                    // TODO: Reset state of form
                    // TODO: Report issue on form
                });

        }, JSON.parse(axiosDelay()));
    };

    const onGroupTypeChange = async (value) => {
        await trigger(['groupType']);
		setGroupType(value);
    };

    return (
        <StyledDialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">New User</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                    <FormControl variant="standard" className={classes.margin}>
                        <InputLabel htmlFor="input-with-icon-adornment">EMail Address</InputLabel>
                        <Input
                            {...register("email")//,
                                // {
                                //     required: true,
                                //     pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
                                // })
                            }
                            name="email"
                            id="email"
                            startAdornment={
                                <InputAdornment position="start">
                                    <EmailIcon />
                                </InputAdornment>
                            }
                            inputProps={{
                                "aria-label": "EMail"
                            }}
                        />
                        {errors.email && <p style={{color: 'red'}}>{errors?.email?.message}</p>}
                    </FormControl>
                    <FormControl variant="standard" className={classes.margin}>
                        <InputLabel htmlFor="input-with-icon-adornment">Group</InputLabel>
                            <Select
                                variant="standard"
                                {...register("groupType")}
                                name="groupType"
                                id="groupType"
                                displayEmpty>
                            {groupTypes.map((r, index) =>
                                <MenuItem key={index} value={r.value} primarytext={r.label}>{r.label}</MenuItem>
                            )}
                        </Select>
                        {errors.groupType && <p style={{color: 'red'}}>{errors.groupType.message}</p>}
                    </FormControl>
                    <DialogActions className={classes.formEmbeddedActions}>
                        <Button onClick={handleClose} color="primary" disabled={formState.isSubmitting}>
                            Cancel
                        </Button>
                        <Button color="primary" type="submit" disabled={formState.isSubmitting}>
                            Submit
                        </Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </StyledDialog>
    );
}
